import React from "react";
import { Form } from "@redriver/cinnamon";

const QuarterlyServiceTermsForm = ({ onChangeUpload, editMode, ...props }) => {
    return (
        <Form {...props}>
            <Form.FileUpload
                field="templateUpload"
                label="Upload Terms"
                fileExtensionTypes={["docx"]}
                customValidator={(_, __, ___, { value }) => {
                    !!value?.templateUpload && onChangeUpload(value?.templateUpload);
                }}
                required={!editMode}
            />
        </Form>
    );
};

export default QuarterlyServiceTermsForm;
